export { }
declare global {
    export interface Number {
        toLocalePrice(locale?: string): string;
        customRound(decimalPlaces: number): string;
        roundAwayFromZero(decimals: number): number;
        qtyRoundAwayFromZero(): number;
        priceRoundAwayFromZero(): number;
        discountRoundAwayFromZero(): number;
    }
}

Number.prototype.toLocalePrice = function (locale?: string): string {
    const formattedNumber = this.toLocaleString(locale ?? 'pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    return formattedNumber;
};

Number.prototype.customRound = function (decimalPlaces: number): string {
    let factor = Math.pow(10, decimalPlaces);
    return (Math.round(Number(this) * factor) / factor).toString();
}

Number.prototype.roundAwayFromZero = function (decimals: number): number {
    const factor = Math.pow(10, decimals);
    const rounded = Math.round((Number(this) + Number.EPSILON) * factor);
    return (rounded > 0 ? Math.ceil : Math.floor)(rounded) / factor;
}

Number.prototype.priceRoundAwayFromZero = function (): number {
    return Number(this).roundAwayFromZero(2);
}

Number.prototype.qtyRoundAwayFromZero = function (): number {
    return Number(this).roundAwayFromZero(4);
}

Number.prototype.discountRoundAwayFromZero = function (): number {
    const scaled = (Number(this) * 100).roundAwayFromZero(2);
    const floor = Math.floor(scaled);
    const fraction = scaled - floor;

    const rounded = (fraction === 0.5)
        ? (floor % 2 === 0 ? floor : floor + 1)
        : Math.round(scaled);

    return rounded / 100;
}